import { HeaderText as SharedHeaderText } from '../../components/atomic/text/header_text/HeaderText';
import headerTextImg from './header_text.png';
import './HeaderText.css';

/** From Figma — «ПАУЗА», top 149.5 / left 436. */
export function HeaderText() {
  return (
    <SharedHeaderText
      className="pause-header-text"
      src={headerTextImg}
      alt="Пауза"
    />
  );
}
